import { type ReactNode, useCallback, useRef, useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { ToastContext, type ToastTone } from '../lib/toast'

type Toast = { id: number; text: string; tone: ToastTone }

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([])
  const next = useRef(1)
  const show = useCallback((text: string, tone: ToastTone = 'good') => {
    const id = next.current++
    setToasts((t) => [...t.slice(-2), { id, text, tone }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3200)
  }, [])
  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+148px)] z-50 grid justify-items-center gap-2 px-4" aria-live="polite">
        <AnimatePresence>
          {toasts.map((t) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 12, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 8 }}
              transition={{ duration: 0.18 }}
              className="inline-flex items-center gap-2.5 rounded-full bg-ink px-4 py-2.5 text-[14px] font-medium text-paper shadow-lift"
            >
              <i className={`size-2 rounded-full ${t.tone === 'good' ? 'bg-good' : 'bg-danger'}`} />
              {t.text}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>
  )
}
